module.exports = __webpack_public_path__ + "img/IMG_20191130_012057.a7c160a1.jpg";